import script from "./HeaderComp.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeaderComp.vue?vue&type=script&setup=true&lang=ts"

import "./HeaderComp.vue?vue&type=style&index=0&id=13681f0c&scoped=true&lang=css"

import exportComponent from "D:\\laoyou\\rez-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13681f0c"]])

export default __exports__